<template lang="pug">
.dialog-wrapper.flex-mid(v-if="show" @touchmove.prevent)
  .dialog-body
    .title {{title}}
    .content {{content}}
    .operation
      .btn.flex-mid(@click="$emit('ok')", :class="{primary: okPrimary}") {{okText}}
      .btn.flex-mid(@click="$emit('cancel')", :class="{primary: !okPrimary}") {{cancelText}}
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '关闭蚂蚁森林能量',
    },
    okPrimary: {
      type: Boolean,
      default: false,
    },
    content: {
      type: String,
      default: '关闭后您的骑行开始时间、结束时间、骑行里程，以及在哈啰绑定的支付宝账户信息将不再传送给支付宝，使用哈啰APP将不再产生蚂蚁森林能量。',
    },
    okText: {
      type: String,
      default: '确认关闭',
    },
    cancelText: {
      type: String,
      default: '暂不关闭',
    },
  },
  methods: { },
};
</script>

<style scoped lang="less">
.dialog-wrapper {
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  position: fixed;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.7);

  .dialog-body {
    padding: 0.24rem 0.16rem 0.16rem;
    width: 3.2rem;
    min-height: 1.85rem;
    background: #fff;
    border-radius: 0.12rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;

    .title {
      font-size: 0.18rem;
      font-weight: 500;
      color: #242729;
      line-height: 0.25rem;
    }

    .content {
      font-size: 0.14rem;
      font-weight: 400;
      color: #5a6066;
      line-height: 0.2rem;
      text-align: left;
      margin-top: 0.12rem;
      margin-bottom: 0.2rem;
    }

    .operation {
      display: flex;
      justify-content: space-between;
      width: 100%;

      .btn {
        width: 1.4rem;
        height: 0.48rem;
        border-radius: 0.08rem;
        border: 0.01rem solid #08f;
        font-size: 0.18rem;
        color: #0081f1;
        line-height: 0.25rem;
        order: 1;

        &.primary {
          color: #fff;
          background: #08f;
          border: none;
          order: 2;
        }
      }
    }
  }
}
</style>
